import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import AnimateOnScroll, { StaggerContainer, StaggerItem } from "@/components/AnimateOnScroll";
import { workflowSteps } from "@/lib/data";
import { useTranslation } from "react-i18next";

export default function ProsesPage() {
  const { t } = useTranslation();
  return (
    <>
      <section className="pt-32 pb-16 relative">
        <div className="absolute inset-0 bg-grid-pattern bg-grid opacity-30" />
        <div className="section-container section-padding relative z-10">
          <AnimateOnScroll className="text-center max-w-3xl mx-auto">
            <span className="text-neon-400 font-mono text-sm tracking-widest uppercase">{t('home.proses_page.kategori')}</span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mt-3 mb-6 gradient-text-white">
              {t('home.proses_page.title_main')}<span className="gradient-text">{t('home.proses_page.title_highlight')}</span>
            </h1>
            <p className="text-white/50 text-lg leading-relaxed">
              {t('home.proses_page.desc')}
            </p>
          </AnimateOnScroll>
        </div>
      </section>

      <section className="pb-24">
        <div className="section-container section-padding">
          <StaggerContainer className="space-y-6" staggerDelay={0.1}>
            {((t('home.proses_page.workflowSteps', { returnObjects: true }) || []) as any[]).map((step, index) => {
              const originalStep = workflowSteps[index] || workflowSteps[0];
              return (
              <StaggerItem key={originalStep.number}>
                <div className="glass-card-hover p-8 md:p-10">
                  <div className="grid md:grid-cols-[auto_1fr_1fr] gap-8 items-start">
                    <div className="flex flex-col items-center">
                      <span className="text-4xl md:text-5xl font-bold gradient-text font-mono">
                        {originalStep.number}
                      </span>
                      <span className="mt-2 px-3 py-1 text-xs bg-neon-500/10 text-neon-400 rounded-full font-mono">
                        {step.duration}
                      </span>
                    </div>
                    <div>
                      <h2 className="text-xl md:text-2xl font-bold text-white mb-3">{step.title}</h2>
                      <p className="text-white/40 leading-relaxed">{step.description}</p>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-3">
                        {t('home.proses_page.label_deliverables')}
                      </h4>
                      <ul className="space-y-2">
                        {step.details.map((detail: string) => (
                          <li key={detail} className="flex items-center gap-2 text-sm text-white/50">
                            <CheckCircle2 className="w-4 h-4 text-neon-500/50 flex-shrink-0" />
                            {detail}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  {index < workflowSteps.length - 1 && (
                    <div className="hidden md:block mt-6 ml-[2.4rem] h-8 w-px bg-gradient-to-b from-neon-500/20 to-transparent" />
                  )}
                </div>
              </StaggerItem>
              );
            })}
          </StaggerContainer>
        </div>
      </section>

      <section className="pb-32 pt-10 relative z-10">
        <div className="section-container section-padding text-center">
          <AnimateOnScroll>
            <h2 className="text-3xl md:text-4xl font-bold gradient-text-white mb-4">
              {t('home.proses_page.cta_title')}
            </h2>
            <p className="text-white/50 max-w-xl mx-auto mb-8">
              {t('home.proses_page.cta_desc')}
            </p>
            <Link to="/konsultasi" className="btn-primary inline-flex">
              {t('home.proses_page.btn_mulai')}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </AnimateOnScroll>
        </div>
      </section>
    </>
  );
}
